export default __webpack_public_path__ + "assets/images/9551d243795fc4aaf95301cd3671a910.png";